import db from "../dexie-db/db";
export default class SyncBoxState {
    configId;
    constructor(configId) {
        this.configId = configId;
    }
    async updateState(state) {
        await db.transaction('rw', db.syncBoxState, async () => {
            const currentState = await db.syncBoxState.get(this.configId);
            await db.syncBoxState.put({
                configId: this.configId,
                lastPulledAt: state.lastPulledAt ?? currentState?.lastPulledAt ?? 0,
                lastPulledId: state.lastPulledId ?? currentState?.lastPulledId,
                lastSyncedAt: state.lastSyncedAt ?? currentState?.lastSyncedAt ?? 0,
                lastAccessedAt: state.lastAccessedAt ?? currentState?.lastAccessedAt ?? 0,
            });
        });
    }
    async getLastPulledInfo() {
        const currentState = await db.syncBoxState.get(this.configId);
        return {
            lastPulledAt: currentState?.lastPulledAt ?? 0,
            lastPulledId: currentState?.lastPulledId,
        };
    }
    async getLastSyncedInfo() {
        const currentState = await db.syncBoxState.get(this.configId);
        return {
            lastSyncedAt: currentState?.lastSyncedAt ?? 0,
        };
    }
    async updateLastPulledInfo(info) {
        await this.updateState(info);
    }
    async updateLastSyncedInfo(info) {
        await this.updateState(info);
    }
    async touchLastAccessed() {
        await this.updateState({
            lastAccessedAt: Date.now(),
        });
    }
    async getLastAccessedAt() {
        const currentState = await db.syncBoxState.get(this.configId);
        return currentState?.lastAccessedAt ?? 0;
    }
    static async delete(configId) {
        await db.syncBoxState.delete(configId);
    }
}
